<script>
// Pure presentational vertical timeline — BoardForm.vue computes segments/
// warnings from its own form state and passes them in; this component only
// renders. Kept separate so the (fairly involved) date-math in BoardForm
// doesn't have to also carry layout concerns.
export default {
  name: "BoardTimeline",
  props: {
    // [{key, label, startLabel, endLabel, conflict}]
    segments: {type: Array, default: () => []},
    // {label, dateLabel} | null
    marker: {type: Object, default: null},
    warnings: {type: Array, default: () => []},
  },
};
</script>

<template>
  <div class="board-timeline">
    <div v-if="!segments.length" class="board-timeline__empty">
      Sanalarni kiriting — vaqt chizig'i shu yerda ko'rinadi
    </div>

    <ol v-else class="board-timeline__list">
      <li
          v-for="seg in segments"
          :key="seg.key"
          class="board-timeline__item"
          :class="{'board-timeline__item--conflict': seg.conflict}"
      >
        <span class="board-timeline__dot" :style="{background: seg.color}"/>
        <div class="board-timeline__body">
          <div class="board-timeline__label">{{ seg.label }}</div>
          <div class="board-timeline__range">{{ seg.startLabel }} — {{ seg.endLabel }}</div>
        </div>
      </li>

      <li v-if="marker" class="board-timeline__item board-timeline__item--marker">
        <span class="board-timeline__dot board-timeline__dot--marker"/>
        <div class="board-timeline__body">
          <div class="board-timeline__label">{{ marker.label }}</div>
          <div class="board-timeline__range">{{ marker.dateLabel }}</div>
        </div>
      </li>
    </ol>

    <el-alert
        v-if="warnings.length"
        type="warning"
        show-icon
        :closable="false"
        class="board-timeline__warnings"
    >
      <ul class="board-timeline__warning-list">
        <li v-for="(w, i) in warnings" :key="i">{{ w }}</li>
      </ul>
    </el-alert>
  </div>
</template>

<style scoped lang="scss">
.board-timeline {
  &__empty {
    font-size: 12px;
    color: #999;
    padding: 12px 0;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 10px;
    border-left: 3px solid transparent;
    border-radius: 4px;
    position: relative;

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      left: 15px;
      top: 26px;
      bottom: -6px;
      width: 1px;
      background: rgba(137, 141, 141, 0.3);
    }

    &--conflict {
      border-left-color: #f56c6c;
      background: rgba(245, 108, 108, 0.06);
    }

    &--marker {
      .board-timeline__label {
        font-style: italic;
      }
    }
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-top: 4px;
    flex-shrink: 0;

    &--marker {
      background: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__label {
    font-size: 12px;
    font-weight: 600;
    color: #333;
  }

  &__range {
    font-size: 12px;
    color: #666;
  }

  &__warnings {
    margin-top: 10px;
  }

  &__warning-list {
    margin: 0;
    padding-left: 18px;
    font-size: 12px;
  }
}
</style>
